import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import DashboardV2 from './pages/DashboardV2';
import DashboardDark from './pages/DashboardDark';
import DashboardLight from './pages/DashboardLight';
import DashboardWrapper from './pages/DashboardWrapper';
import Customers from './pages/Customers';
import BulkImportCustomers from './pages/BulkImportCustomers';
import IPConflictReport from './pages/IPConflictReport';
import Invoices from './pages/Invoices';
import GenerateBilling from './pages/GenerateBilling';
import Payments from './pages/Payments';
import Settings from './pages/Settings';
import CompanySettings from './pages/CompanySettings';
import Branches from './pages/Branches';
import Owners from './pages/Owners';
import OwnersManagement from './pages/OwnersManagement';
import Vouchers from './pages/Vouchers';
import ManajemenVoucher from './pages/ManajemenVoucher';
import VoucherTemplateEditor from './pages/VoucherTemplateEditor';
import VoucherAgents from './pages/VoucherAgents';
import VoucherMigration from './pages/VoucherMigration';
import AgentDashboard from './pages/AgentDashboard';
import HotspotPackages from './pages/HotspotPackages';
import OLTDevices from './pages/OLTDevices';
import WANDevices from './pages/WANDevices';
import WANOverview from './pages/WANOverview';
import OLTDetail from './pages/OLTDetail';
import ACSConfig from './pages/ACSConfig';
import ONTProvisioning from './pages/ONTProvisioning';
import Users from './pages/Users';
import Devices from './pages/Devices';
import CustomerDetail from './pages/CustomerDetail';
import DeviceDetail from './pages/DeviceDetail';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';
import TicketReports from './pages/TicketReports';
import PublicTicketUpdate from './pages/PublicTicketUpdate';
import SystemTools from './pages/SystemTools';
import MigrasiData from './pages/MigrasiData';
import Profile from './pages/Profile';
import AdminTools from './pages/AdminTools';
import Login from './pages/Login';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentSimulator from './pages/PaymentSimulator';
import PaymentFailure from './pages/PaymentFailure';
import PaymentConfirmation from './pages/PaymentConfirmation';
import DuitkuPayment from './pages/DuitkuPayment';
import TripayPayment from './pages/TripayPayment';
import CustomerLogin from './pages/CustomerLogin';
import CustomerDashboard from './pages/CustomerDashboard';
import FinancialReports from './pages/FinancialReports';
import BhpUsoReport from './pages/BhpUsoReport';
import SystemInfo from './pages/SystemInfo';
import Expenses from './pages/Expenses';
import Revenue from './pages/Revenue';
import WhatsAppSettings from './pages/WhatsAppSettings';
import WhatsAppCost from './pages/WhatsAppCost';
import EmailSMTP from './pages/EmailSMTP';
import ServicePlans from './pages/ServicePlans';
import IPPoolManagement from './pages/IPPoolManagement';
import MikrotikSettings from './pages/MikrotikSettings';
import MikrotikMonitoring from './pages/MikrotikMonitoring';
import IsolirPageEditor from './pages/IsolirPageEditor';
import IsolirGlobalEditor from './pages/IsolirGlobalEditor';
import BackupManager from './pages/BackupManager';
import OwnerDepositManagement from './pages/OwnerDepositManagement';
import OwnerDepositDashboard from './pages/OwnerDepositDashboard';
import OwnerStatistics from './pages/OwnerStatistics';
import MPanel from './pages/MPanel';
import PaymentGatewaySettings from './pages/PaymentGatewaySettings';
import AutomationControl from './pages/AutomationControl';
import IsolirManagement from './pages/IsolirManagement';
import SubnetPlanner from './pages/SubnetPlanner';
import ReminderSettings from './pages/ReminderSettings';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import HotspotCustomizer from './pages/HotspotCustomizer';
import HelpGuide from './pages/HelpGuide';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import SuperAdminHomeDashboard from './pages/SuperAdminHomeDashboard';
import TenantBillingManagement from './pages/TenantBillingManagement';
import SuperAdminVPNManagement from './pages/SuperAdminVPNManagement';
import RolesPermissions from './pages/RolesPermissions';
import RoleMatrix from './pages/RoleMatrix';
import CompanyProfile from './pages/CompanyProfile';
import Accounting from './pages/Accounting';
import Inventory from './pages/Inventory';
import { BrandingProvider } from './contexts/BrandingContext';
import SubscriptionPlansManager from './pages/SubscriptionPlansManager';
import RADIUSGuide from './pages/RADIUSGuide';
import RADIUSOnlyGuide from './pages/RADIUSOnlyGuide';
import HybridModeGuide from './pages/HybridModeGuide';
import VPNSetupGuide from './pages/VPNSetupGuide';
import RADIUSManagement from './pages/RADIUSManagement';
import RADIUSConfig from './pages/RADIUSConfig';
import ACSServerMonitoring from './pages/ACSServerMonitoring';
import FreeRADIUSMonitoring from './pages/FreeRADIUSMonitoring';
import L2TPManagement from './pages/L2TPManagement';
import TenantVPNManager from './pages/TenantVPNManager';
import GatewayPermissions from './pages/GatewayPermissions';
import SuperAdminTools from './pages/SuperAdminTools';
import SuperAdminRouterStatus from './pages/SuperAdminRouterStatus';
import DeviceInventory from './pages/DeviceInventory';
import PublicRegistration from './pages/PublicRegistration';
import HotspotRedeem from './pages/HotspotRedeem';
import RegistrationInbox from './pages/RegistrationInbox';
import BranchManagement from './pages/BranchManagement';
import CompanyInfo from './pages/CompanyInfo';
import SystemSettings from './pages/SystemSettings';
import AppVersion from './pages/AppVersion';
import SystemMonitor from './pages/SystemMonitor';
import TenantCustomerLogin from './pages/TenantCustomerLogin';
import TenantCustomerDashboard from './pages/TenantCustomerDashboard';
import CustomerPortalLanding from './pages/CustomerPortalLanding';
import OnlinePaymentReport from './pages/OnlinePaymentReport';
import VoucherIncome from './pages/VoucherIncome';
import LiveSessions from './pages/LiveSessions';
import HotspotOnline from './pages/HotspotOnline';
import PPPoEOnline from './pages/PPPoEOnline';
import ACSMonitoring from './pages/ACSMonitoring';
import SessionManagement from './pages/SessionManagement';
import TenantSubscription from './pages/TenantSubscription';
import ODPManagement from "./pages/ODPManagement";
import IPAllocations from "./pages/IPAllocations";
import ODPMap from "./pages/ODPMap";
import CustomerMap from "./pages/CustomerMap";
import Reports from './pages/Reports';
import Receivables from './pages/Receivables';
import Trash from './pages/Trash';
import AuditLogs from './pages/AuditLogs';
import EmailLogs from './pages/EmailLogs';
import Reconciliation from './pages/Reconciliation';
import Forbidden403 from './pages/Forbidden403';
import Layout from './components/Layout';
import RoleGuardOutlet from './components/RoleGuardOutlet';
import BuildVersionWatcher from './components/BuildVersionWatcher';
import InstanceBadge from './components/InstanceBadge';
import IdleTimeout from './components/IdleTimeout';
import { Toaster } from './components/ui/sonner';
import { AppProvider } from './contexts/AppContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Subdomain to Tenant mapping for custom portal domains
const PORTAL_DOMAIN_MAPPING = {
  'portal.radiuslink.id': 'T06122503',
  'member.kumarahotspot.com': 'T06122503',
  // Add more mappings as needed: 'portal.otherisp.com': 'T12345678'
};

// Check if current domain is a portal subdomain
const getPortalTenantCode = () => {
  const hostname = window.location.hostname;
  return PORTAL_DOMAIN_MAPPING[hostname] || null;
};

// Tag <html> with data-portal-member=true so global CSS can hide scrollbar on portal member subdomain
if (typeof document !== 'undefined' && PORTAL_DOMAIN_MAPPING[window.location.hostname]) {
  document.documentElement.setAttribute('data-portal-member', 'true');
}

// Root redirect component
const RootRedirect = () => {
  const { isAuthenticated, loading } = useAuth();
  
  // Check if accessing from portal subdomain
  const portalTenantCode = getPortalTenantCode();
  if (portalTenantCode) {
    // Redirect to tenant portal login
    return <Navigate to={`/p/${portalTenantCode}/login`} replace />;
  }
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }
  
  return isAuthenticated ? <Navigate to="/app/dashboard" replace /> : <Navigate to="/login" replace />;
};

// Portal-aware Login wrapper - redirects to tenant portal if on portal subdomain
const PortalAwareLogin = () => {
  const portalTenantCode = getPortalTenantCode();
  if (portalTenantCode) {
    return <Navigate to={`/p/${portalTenantCode}/login`} replace />;
  }
  return <Login />;
};

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <AppProvider>
          <div className="App">
            <BuildVersionWatcher />
            <BrowserRouter>
              <IdleTimeout />
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/register/:slug" element={<PublicRegistration />} />
              <Route path="/hs/redeem" element={<HotspotRedeem />} />
            <Route path="/login" element={<PortalAwareLogin />} />
              <Route path="/customer-login" element={<CustomerLogin />} />
              <Route path="/customer/dashboard" element={<CustomerDashboard />} />
              <Route path="/ticket/:token" element={<PublicTicketUpdate />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/app/payment-simulator" element={<PaymentSimulator />} />
              <Route path="/payment/failure" element={<PaymentFailure />} />
              <Route path="/payment/confirmation" element={<PaymentConfirmation />} />
              <Route path="/payment/duitku" element={<DuitkuPayment />} />
              <Route path="/payment/tripay" element={<TripayPayment />} />
              
              {/* Tenant-specific Customer Portal Routes */}
              <Route path="/p/:tenantSlug/login" element={<TenantCustomerLogin />} />
              <Route path="/p/:tenantSlug/dashboard" element={<TenantCustomerDashboard />} />
              <Route path="/p/:tenantSlug/portal-info" element={<CustomerPortalLanding />} />
              
              <Route path="/app" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route element={<RoleGuardOutlet />}>
                <Route index element={<Navigate to="/app/dashboard" replace />} />
                <Route path="403" element={<Forbidden403 />} />
                <Route path="dashboard" element={<DashboardWrapper />} />
                <Route path="superadmin-home" element={<SuperAdminHomeDashboard />} />
                <Route path="session-management" element={<SessionManagement />} />
                <Route path="customers" element={<Customers />} />
                <Route path="customers/pppoe" element={<Customers filter="pppoe" />} />
                <Route path="customers/hotspot" element={<Customers filter="hotspot" />} />
                <Route path="customers/dhcp" element={<Customers filter="dhcp" />} />
                <Route path="customers/ip-conflicts" element={<IPConflictReport />} />
                <Route path="customers/bulk-import" element={<BulkImportCustomers />} />
                <Route path="device-inventory" element={<DeviceInventory />} />
                <Route path="registrations" element={<RegistrationInbox />} />
                <Route path="customers/:customerId" element={<CustomerDetail />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="invoices/generate" element={<GenerateBilling />} />
                <Route path="payments" element={<Payments />} />
                <Route path="branches" element={<Branches />} />
                <Route path="owners" element={<OwnersManagement />} />
                <Route path="owner-statistics" element={<OwnerStatistics />} />
                <Route path="vouchers" element={<Vouchers />} />
                <Route path="manajemen-voucher" element={<ManajemenVoucher />} />
                <Route path="voucher-template-editor" element={<VoucherTemplateEditor />} />
                <Route path="voucher-agents" element={<VoucherAgents />} />
                <Route path="voucher-migration" element={<VoucherMigration />} />
                <Route path="agent-dashboard" element={<AgentDashboard />} />
                <Route path="hotspot-packages" element={<HotspotPackages />} />
                <Route path="olt" element={<OLTDevices />} />
                <Route path="olt/:id" element={<OLTDetail />} />
                <Route path="acs-config" element={<ACSConfig />} />
                <Route path="wan-devices" element={<WANDevices />} />
                <Route path="wan-overview" element={<WANOverview />} />
                <Route path="ont-provisioning" element={<ONTProvisioning />} />
                <Route path="system-tools" element={<SystemTools />} />
                <Route path="migrasi-data" element={<MigrasiData />} />
                <Route path="users" element={<Users />} />
                <Route path="roles" element={<RolesPermissions />} />
                <Route path="role-matrix" element={<RoleMatrix />} />
                <Route path="devices" element={<Devices />} />
                <Route path="devices/:deviceId" element={<DeviceDetail />} />
                <Route path="tickets" element={<Tickets />} />
                <Route path="tickets/reports" element={<TicketReports />} />
                <Route path="tickets/:ticketId" element={<TicketDetail />} />
                <Route path="reports" element={<FinancialReports />} />
                <Route path="laporan-bulanan" element={<Reports />} />
                <Route path="receivables" element={<Receivables />} />
                <Route path="trash" element={<Trash />} />
                <Route path="audit-logs" element={<AuditLogs />} />
                <Route path="email-logs" element={<EmailLogs />} />
                <Route path="reconciliation" element={<Reconciliation />} />
                <Route path="bhp-uso-report" element={<BhpUsoReport />} />
                <Route path="expenses" element={<Expenses />} />
                <Route path="revenue" element={<Revenue />} />
                <Route path="accounting" element={<Accounting />} />
                <Route path="voucher-income" element={<VoucherIncome />} />
                <Route path="whatsapp-cost" element={<WhatsAppCost />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="service-plans" element={<ServicePlans />} />
                <Route path="ip-pools" element={<IPPoolManagement />} />
                <Route path="whatsapp" element={<WhatsAppSettings />} />
                <Route path="email-smtp" element={<EmailSMTP />} />
                <Route path="mikrotik" element={<MikrotikSettings />} />
                <Route path="mikrotik-monitoring" element={<MikrotikMonitoring />} />
                <Route path="isolir-page-editor" element={<IsolirPageEditor />} />
                <Route path="owner-deposits" element={<OwnerDepositManagement />} />
                <Route path="my-deposits" element={<OwnerDepositDashboard />} />
                <Route path="monitoring" element={<MikrotikMonitoring />} />
                <Route path="live-sessions" element={<LiveSessions />} />
                <Route path="hotspot-aktif" element={<HotspotOnline />} />
                <Route path="pppoe-online" element={<PPPoEOnline />} />
                <Route path="acs-monitoring" element={<ACSMonitoring />} />
                <Route path="payment-gateway" element={<PaymentGatewaySettings />} />
                <Route path="online-payment-report" element={<OnlinePaymentReport />} />
                <Route path="mpanel" element={<MPanel />} />
                <Route path="branches" element={<Branches />} />
                <Route path="automation" element={<AutomationControl />} />
                <Route path="isolir-management" element={<IsolirManagement />} />
                <Route path="subnet-planner" element={<SubnetPlanner />} />
                <Route path="reminder-settings" element={<ReminderSettings />} />
                <Route path="analytics" element={<AnalyticsDashboard />} />
                <Route path="company-settings" element={<CompanySettings />} />
                <Route path="hotspot-customizer" element={<HotspotCustomizer />} />
                <Route path="system-info" element={<SystemInfo />} />
                <Route path="help" element={<HelpGuide />} />
                <Route path="super-admin" element={<SuperAdminDashboard />} />
                <Route path="tenant-billing" element={<TenantBillingManagement />} />
                <Route path="superadmin-vpn-management" element={<SuperAdminVPNManagement />} />
                <Route path="superadmin-router-status" element={<SuperAdminRouterStatus />} />
                {/* <Route path="role-management" element={<RoleManagement />} /> - Removed: merged into /roles */}
                <Route path="company-profile" element={<CompanyProfile />} />
                <Route path="subscription-plans" element={<SubscriptionPlansManager />} />
                <Route path="radius-guide" element={<RADIUSGuide />} />
                <Route path="radius-only-guide" element={<RADIUSOnlyGuide />} />
                <Route path="hybrid-mode-guide" element={<HybridModeGuide />} />
                <Route path="vpn-setup-guide" element={<VPNSetupGuide />} />
                <Route path="radius-management" element={<RADIUSManagement />} />
                <Route path="radius-config" element={<RADIUSConfig />} />
                <Route path="acs-server" element={<ACSServerMonitoring />} />
                <Route path="freeradius" element={<FreeRADIUSMonitoring />} />
                <Route path="l2tp-management" element={<L2TPManagement />} />
                <Route path="tenant-vpn" element={<TenantVPNManager />} />
                <Route path="gateway-permissions" element={<GatewayPermissions />} />
                <Route path="superadmin-tools" element={<SuperAdminTools />} />
                <Route path="isolir-global-editor" element={<IsolirGlobalEditor />} />
                <Route path="backup-manager" element={<BackupManager />} />
                <Route path="branch-management" element={<BranchManagement />} />
                <Route path="company-info" element={<CompanyInfo />} />
                <Route path="system-settings" element={<SystemSettings />} />
                <Route path="app-version" element={<AppVersion />} />
                <Route path="profile" element={<Profile />} />
                <Route path="admin-tools" element={<AdminTools />} />
                <Route path="settings" element={<Settings />} />
                <Route path="system-monitor" element={<SystemMonitor />} />
                <Route path="tenant-subscription" element={<TenantSubscription />} />
                <Route path="odp-management" element={<ODPManagement />} />
                <Route path="ip-allocations" element={<IPAllocations />} />
                <Route path="odp-map" element={<ODPMap />} />
                <Route path="customer-map" element={<CustomerMap />} />
                <Route path="dashboard-v2" element={<DashboardV2 />} />
                <Route path="dashboard-dark" element={<DashboardDark />} />
                <Route path="dashboard-light" element={<DashboardLight />} />
                </Route>
              </Route>
              {/* 2026-05-20 legacy redirect: kalau user hit URL tanpa /app prefix, redirect ke /app/* */}
              <Route path="/customers/ip-conflicts" element={<Navigate to="/app/customers/ip-conflicts" replace />} />
              <Route path="/customers/pppoe" element={<Navigate to="/app/customers/pppoe" replace />} />
              <Route path="/customers/hotspot" element={<Navigate to="/app/customers/hotspot" replace />} />
              <Route path="/customers/dhcp" element={<Navigate to="/app/customers/dhcp" replace />} />
              <Route path="/customers" element={<Navigate to="/app/customers" replace />} />
              <Route path="/dashboard" element={<Navigate to="/app/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
          <InstanceBadge />
        </div>
      </AppProvider>
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;